import React, {useState, useEffect} from 'react';
import {
    Form,
    message,
    Select,
    DatePicker,
} from 'antd';
import {SFuncModal} from 'shj-components';
import {appointmentTypeEnum} from '@/services/customerServices';
import dayjs from "dayjs";
import {appointmentForCall} from "@/services/callCenter";

export function openAppointmentCallModal(props) {
    const destroy = () => {
        dialog.destroy();
    };
    const dialog: any = SFuncModal({
        title: '云客服邀约',
        width: 400,
        vanish: true,
        content: <ContentDom onClose={destroy} {...props} />,
    });
}

const ContentDom: React.FC<any> = ({ fn, onClose, clueId,  ...rest }) => {
    const [loading, setLoading] = useState(false);
    const [form] = Form.useForm();
    const [appointmentList, setAppointmentList] = useState<any[]>([]);

    useEffect(() => {
        onInit()
    }, [])
    const range = (start: number, end: number) => {
        const result = [];
        for (let i = start; i < end; i++) {
            result.push(i);
        }
        return result;
    };
    const disabledDateTime = (data: any) => {
        const _hours = dayjs().hour()
        const isToday = dayjs(data).isSame(dayjs(), 'day')
        const disabledHours = range(0, 60).splice(0, _hours+1)
        return {
            disabledHours: () => (!isToday && data)? [] :disabledHours,
            disabledMinutes: () => [],
            disabledSeconds: () => [],
        }
    }
    const onInit = () => {
        appointmentTypeEnum().then(((res: any) => {
            setAppointmentList(res || [])
        }))

    }
    const onFinish = () => {
        form.validateFields().then((value: any) => {
            const params = {
                ...value,
                clueId,
                appointmentDate: value.appointmentDate ? dayjs(value.appointmentDate).format('YYYY-MM-DD HH:mm:ss') : '',
            }
            setLoading(true);
            appointmentForCall(params).then((res: any) => {
                message.success(res?.message || '操作成功');
                fn && fn();
                onClose && onClose();
            }).finally(() => {
                setLoading(false);
            });
        })
    }
    return <SFuncModal.Content
        cancelText="取消"
        onCancel={onClose}
        onOk={onFinish}
        confirmLoading={loading}
    >
        <Form form={form} layout='vertical'>
            <Form.Item
                label="预约类型"
                name="appointmentType"
                rules={[{required: true, message: '请选择预约类型'}]}
            >
                <Select
                    placeholder="请选择预约类型"
                    allowClear
                    fieldNames={{label: 'description', value: 'key'}}
                    options={appointmentList}
                />
            </Form.Item>
            <Form.Item label="见面时间" name="appointmentDate" rules={[{required: true, message: '请选择见面时间'}]}>
                <DatePicker
                    format="YYYY-MM-DD HH:00"
                    showTime={{format: 'YYYY-MM-DD HH:00'}}
                    placeholder="请选择见面时间"
                    style={{width: "100%"}}
                    disabledDate={current => {
                        return current && current < dayjs().subtract(1, 'day')
                    }}
                    disabledTime={disabledDateTime}
                />
            </Form.Item>
        </Form>
    </SFuncModal.Content>
}
